import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { SerieNF } from '../interfaces/serieNF';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { UnMedida } from '../interfaces/un-medida';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class SerieNFService {


  readonly path = '/serie';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  saveOrUpdate(cadastro: SerieNF): Observable<SerieNF> {
    return this.http.put<SerieNF>(`${this.jwtAuthService.apiUrl + this.path}`, cadastro);
  }

  getItem(id: number ): Observable<SerieNF> {
    return this.http.get<SerieNF>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getItemPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<SerieNF>> {
    return this.http.get<PageResult<SerieNF>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getItemPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<SerieNF>> {
    return this.http.get<PageResult<SerieNF>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }
}
